import {
  CHANGE_CHAUFFEUR_PASSWORD,
  CHANGE_CHAUFFEUR_PASSWORD_SUCCESS,
  CHANGE_CHAUFFEUR_PASSWORD_ERROR,
  CHANGE_CHAUFFEUR_PASSWORD_EMPTY,
} from '../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ChangeChauffeurPassword = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_CHAUFFEUR_PASSWORD:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CHANGE_CHAUFFEUR_PASSWORD_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CHANGE_CHAUFFEUR_PASSWORD_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CHANGE_CHAUFFEUR_PASSWORD_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ChangeChauffeurPassword;
